import Icon from "./icon.marko";
import { courseUiText } from "../copy.js";

<li data-ll-pdfs=(input.premium ? "premium" : "free") data-ll-first-module-practice=(input.firstModulePractice ? "1" : false)>
  <for|locked| of=(input.premium ? [false, true] : [false])>
    <${locked ? "button" : "a"}
      class=["ll-course-review", "ll-course-download-card", locked && "is-premium"]
      type=(locked ? "button" : false)
      href=(!locked ? input.href : false)
      target=(!locked ? "_blank" : false)
      rel=(!locked ? "noopener" : false)
      data-ll-pdf-links=(!locked ? "" : false)
      data-ll-pdf-lock=(locked ? "" : false)
      hidden=(!locked && input.premium)
    >
      <span class=["ll-course-review__icon", "ll-course-download-card__icon", input.solutions && "ll-course-download-card__icon--solutions"]><Icon name=(input.solutions ? "check" : "file") size=22/></span>
      <span class="ll-course-review__text">
        <span class="ll-course-kicker">${input.copy.pdfTag}</span>
        <strong>${input.solutions ? input.copy.solutions : input.copy.worksheet}</strong>
      </span>
      <span class="ll-course-download-card__status">
        <Icon name=(locked ? "lock" : "down") size=11 weight=2.6/>
        ${locked ? input.copy.premiumBadge : courseUiText("Download", $global.uiLang || input.copy.uiLang || "en")}
      </span>
    </>
  </for>
</li>
